import { useCallback, useMemo, useState, useEffect } from 'react';
import { hasSnapshot, nullSource, } from 'retil-source';
import { useSubscription } from 'use-subscription';
var MissingToken = Symbol();
export var useSourceLegacy = function (maybeSource, options) {
    if (options === void 0) { options = {}; }
    var hasDefaultValue = 'defaultValue' in options;
    var defaultValue = options.defaultValue, startTransition = options.startTransition;
    var _a = maybeSource || nullSource, core = _a[0], inputSelect = _a[1];
    var select = useMemo(function () {
        return hasDefaultValue
            ? function (core) {
                return hasSnapshot([core, inputSelect]) ? inputSelect(core) : MissingToken;
            }
            : inputSelect;
    }, [hasDefaultValue, inputSelect]);
    var getCurrentValue = useCallback(function () { return select(core); }, [core, select]);
    var subscribe = useMemo(function () {
        return startTransition
            ? function (callback) {
                return core[1](function () {
                    startTransition(callback);
                });
            }
            : core[1];
    }, [core, startTransition]);
    var subscription = useMemo(function () { return ({
        getCurrentValue: getCurrentValue,
        subscribe: subscribe,
    }); }, [getCurrentValue, subscribe]);
    // useSubscription doesn't suspend if its value changes to a missing value.
    // This hack normalizes it to act the same as useMutableSource.
    var _b = useState(), setState = _b[1];
    useEffect(function () {
        if (!hasDefaultValue) {
            return subscribe(function () {
                if (!hasSnapshot([core, select])) {
                    setState((function () {
                        // Because hasSnapshot returns false, this'll throw a promise.
                        select(core);
                    }));
                }
            });
        }
    }, [hasDefaultValue, core, select, subscribe]);
    var value = useSubscription(subscription);
    return value === MissingToken || maybeSource === null ? defaultValue : value;
};
